import wishlist from './wishlist';

wishlist.init();
